import { Component, OnInit, Input } from '@angular/core';
import { LabMDM } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ErrorHandler } from '../utils/error-handler';
import { Template } from '../masterdata/models/template';

@Component({
  selector: 'app-barcode-template',
  templateUrl: './barcode-template.component.html',
  styleUrls: ['./barcode-template.component.css']
})
export class BarcodeTemplateComponent implements OnInit {

  @Input() masterLists: Template[];
  @Input() tableCols: Template[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];


  isNewMasterList: boolean;
  popupTitle: string;
  masterList: Template;
  displayMasterListDialog: boolean = false;
  selectedLabName: string;
  selectedLab: LabMDM;
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedMasterList: Template;
  entityOptions: any[];
  selectedEntity: any;
  isActive: string = "active";
  isLab: string = "lab";
  isEntity: string = "entity";
  isWidth: string = "width";
  isHeight: string = "height";
  isTemplateName:string = "templateName";
  formatHeader:string = "Template";

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) { }

  ngOnInit() {
    this.popupTitle = this.title.slice(0, -1);
    this.entityOptions = [
      { field: 'Tube', label: 'Tube' },
      { field: 'Plate', label: 'Plate' },
      { field: 'Other', label: 'Other' }
    ];
  }

  //Display master Dialog upon clicked on a row
  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
  }

  //Retrieve the Active lab for dropdown
  getActiveOptionsForDropdowns() {
    this._masterDataService.getLabs(true).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.labOptions = results.data;
        this.labOptions.forEach(lab => {
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );

    this.entityOptions.forEach(entity => {
      if (this.masterList && this.masterList.entity && entity.field == this.masterList.entity) {
        this.selectedEntity = entity;
      }
    })
    if (!this.masterList || !this.masterList.entity || this.selectedEntity.field != this.masterList.entity)
      this.selectedEntity = null;
  }

  //Display Add Dialog upon clicking Add button
  showDialogToAddMasterList() {
    this.isNewMasterList = true;
    this.masterList = new Template;
    this.displayMasterListDialog = true;
    this.getActiveOptionsForDropdowns();
    this.selectedLab = null;
    this.selectedEntity = null;
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

  //Insert or update Template
  saveMasterList() {
    let masterLists = [...this.masterLists];

    if (this.isNewMasterList) {
      this.saveMasterData(masterLists);
    }
    else {
      this.updateMasterData(masterLists);
    }
  }

  //Inserts a new Template in DB
  saveMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.entity = this.selectedEntity != null ? this.selectedEntity.field : '';
    this._masterDataService.addTemplate(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists = [...this.masterLists];
        masterLists.push(results.data);
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        this._messageService.addAllErrorMessages(this.errorHandler.handleBBApiErrors(error.error.bbApiError));
        this.displayMasterListDialog = true;
      }
    );
  }

  //Updates a Template in DB
  updateMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.entity = this.selectedEntity != null ? this.selectedEntity.field : '';
    this._masterDataService.updateTemplate(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        this._messageService.addAllErrorMessages(this.errorHandler.handleBBApiErrors(error.error.bbApiError));
        this.displayMasterListDialog = true;
      }
    );
  }

  //Check if the Template Name or Lab is Entered or not, if not disable Save button
  isSaveDisabled() {
    if (this.masterList == undefined || this.masterList == null)
      return true;
    if (!this.masterList.templateName || !this.selectedLab)
      return true;
    return false;
  }
}
